import { Component } from 'react';

// Keeps one broken screen from taking down the whole app. Without this, any
// throw during render unmounts the entire React tree and the user is left
// staring at a permanent blank page with no way back short of a hard reload.
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('GoodGPT render error:', error, info?.componentStack);
  }

  handleRetry = () => {
    this.setState({ error: null });
    // A module-level throw can survive the remount, so force a clean reload
    // rather than looping straight back into the same broken state.
    window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div style={styles.wrap}>
        <div style={styles.card}>
          <div style={styles.mark}>🔆</div>
          <h1 style={styles.title}>Something went wrong</h1>
          <p style={styles.body}>
            GoodGPT hit an unexpected error loading this screen. Reloading usually fixes it.
          </p>
          <button style={styles.button} onClick={this.handleRetry}>
            Reload GoodGPT
          </button>
        </div>
      </div>
    );
  }
}

const styles = {
  wrap: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    background: '#f9fafb',
    fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
  },
  card: {
    maxWidth: 420,
    width: '100%',
    textAlign: 'center',
    background: '#fff',
    border: '1px solid #e5e7eb',
    borderRadius: 16,
    padding: '32px 24px',
  },
  mark: { fontSize: 32, lineHeight: 1, marginBottom: 12 },
  title: { fontSize: 20, fontWeight: 700, color: '#1d1d1f', margin: '0 0 8px' },
  body: { fontSize: 14, lineHeight: 1.5, color: '#6b7280', margin: '0 0 20px' },
  button: {
    background: '#f97316',
    color: '#fff',
    border: 'none',
    borderRadius: 10,
    padding: '11px 22px',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
  },
};

export default ErrorBoundary;